export default __webpack_public_path__ + "static/media/leftArrow.e4c3b75a.svg";